module.exports = __webpack_public_path__ + "img/32.55e35a0e.png";